import {
  Box,
  Button,
  Flex,
  Input,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Icon,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ChakraTabs } from "../../components/tabs/ChakraTabs";
import { AnnexTabList } from "../../shared/mock/AnnexTabList";
import { MainModal } from "../../components/MainModal/MainModal";
import { Layout } from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import {
  fetchAnnexFiles,
  fetchCommentVacancyApplicationCreate,
  fetchDeleteAnnexFiles,
  fetchStatusVacancyApplicationChange,
  fetchVacancyApplicationById,
} from "../../store/slices/vacancyApplications";
import { VacancyApplicationStatusSelect } from "../../components/Controls/VacancyApplicationSelect";
import { BaseTextArea } from "../../components/Controls/BaseTextArea";
import { useFormik } from "formik";
import { getDaysDifferent } from "../../helpers/getDaysDifferent";
import { IChangeVacancyApplicationStatus, ICreateVacancyApplicationComment } from "../../api/vacancyApplications/types";
import { AnnexEventsBlock } from "../../components/AnnexEventsBlock";
import FileUploader from "../../components/FileUploader/FileUploader";
import { deleteVacancyApplication } from "../../api/vacancyApplications";
import PageLoaderWrapper from "../../components/PageLoaderWrapper";
import { FiClock } from "react-icons/fi";
import { formatDate } from "@/helpers/formatDate";
import { BaseSelect } from "@/components/Controls/BaseSelect";

export const AnnexPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabIndex = Number(searchParams.get("tab"));
  const dispatch = useAppDispatch();
  const [currentReasons, setCurrentReasons] = useState<{ id: number; name: string }[]>([]);

  const formikStatus = useFormik<IChangeVacancyApplicationStatus>({
    initialValues: {
      status: "",
      comment: "",
      scheduled_at: "",
      reason_id: null,
    },
    onSubmit: () => {
      if (id) {
        dispatch(fetchStatusVacancyApplicationChange({ id, params: formikStatus.values })).finally(() => dispatch(fetchVacancyApplicationById(id)));
        onClose();
        formikStatus.values.comment = "";
        formikStatus.values.status = "";
        formikStatus.values.scheduled_at = "";
        setWithDate(false);
        setWithTime(false);
        dispatch(fetchVacancyApplicationById(id));
      }
    },
  });
  const [commentText, setCommentText] = useState<string>("");

  const formikComment = useFormik<ICreateVacancyApplicationComment>({
    initialValues: {
      comment: "",
    },
    onSubmit: () => {
      if (id) {
        dispatch(fetchCommentVacancyApplicationCreate({ id, params: formikComment.values })).finally(() => {
          setCommentText("");
          formikComment.values.comment = "";
          dispatch(fetchVacancyApplicationById(id));
        });
      }
    },
  });

  const { currentVacancyApplication, isLoading } = useAppSelector((state: RootState) => state.vacancyApplications);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isDeleteModalOpen, onOpen: onDeleteModalOpen, onClose: onDeleteModalClose } = useDisclosure();

  const setDefaultTabParam = (index: number) => {
    index === 0 ? searchParams.delete("tab") : searchParams.set("tab", String(index));

    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchVacancyApplicationById(id));
    }
  }, [id, dispatch]);

  const [currentFiles, setCurrentFiles] = useState<any>([]);

  const handleAddFiles = (file: File[]) => {
    if (file.length > 0) {
      const newFile: File = file[0];
      currentVacancyApplication &&
        dispatch(fetchAnnexFiles({ params: { attachments: newFile }, id: String(currentVacancyApplication?.id) })).finally(
          () => id && dispatch(fetchVacancyApplicationById(id)),
        );
    }
  };

  const handleDelete = (guid: string) => {
    currentVacancyApplication &&
      dispatch(fetchDeleteAnnexFiles({ params: { attachments_delete: [guid] }, id: String(currentVacancyApplication?.id) })).finally(
        () => id && dispatch(fetchVacancyApplicationById(id)),
      );
  };

  useEffect(() => {
    const resultFiles =
      currentVacancyApplication &&
      currentVacancyApplication?.attachments &&
      Object.entries(currentVacancyApplication.attachments).map(([key, el]) => {
        return {
          name: el.name,
          id: key,
          isCurrentFile: true,
          downloadId: el.id,
        };
      });
    setCurrentFiles(resultFiles);
  }, [currentVacancyApplication]);

  const handleDeleteApplication = () => {
    if (id) {
      deleteVacancyApplication(id)
        .then(() => {
          navigate(`/vacancy/${currentVacancyApplication?.vacancy.id}`);
          onDeleteModalClose();
        })
        .catch((error) => {
          console.error("Error deleting application:", error);
        });
    }
  };

  const [withDate, setWithDate] = useState<boolean>(false);
  const [withTime, setWithTime] = useState<boolean>(false);

  console.log(formikStatus.values);

  return (
    <Layout>
      <PageLoaderWrapper isLoading={isLoading} loadingText="Загрузка данных пристроя...">
        {currentVacancyApplication && (
          <Flex flexDirection="column" gap="10px" paddingRight="16px">
            <Flex justifyContent="space-between" w="100%">
              <Text
                fontWeight={700}
                fontSize={24}
                color="#3b515e"
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                    color: "blue.200",
                  },
                }}
                onClick={() => navigate(`/vacancy/${currentVacancyApplication.vacancy.id}`)}
              >
                {currentVacancyApplication?.vacancy?.name || "Название вакансии не указано"}
              </Text>
              <Button colorScheme="red" variant="outline" onClick={onDeleteModalOpen}>
                Открепить кандидата
              </Button>
            </Flex>

            <Flex justifyContent="space-between" w="100%" h="80vh" gap="24px">
              <Flex flexDirection="column" w="100%">
                <Flex
                  border="1px solid #e1e7ef"
                  borderLeft="4px solid #61a6fa"
                  borderRadius="15px"
                  padding="24px"
                  width="100%"
                  flexDirection="column"
                  gap="16px"
                  backgroundColor="white"
                >
                  <Flex justifyContent="space-between" w="100%">
                    <Text
                      fontWeight={600}
                      fontSize={20}
                      color="#3b515e"
                      sx={{
                        "&:hover": {
                          cursor: "pointer",
                          color: "blue.200",
                        },
                      }}
                      onClick={() => navigate(`/candidate/${currentVacancyApplication.candidate.id}`)}
                    >
                      {currentVacancyApplication?.candidate?.last_name ||
                      currentVacancyApplication?.candidate?.first_name ||
                      currentVacancyApplication?.candidate?.patronymic_name
                        ? `${currentVacancyApplication?.candidate?.last_name || ""} ${currentVacancyApplication?.candidate?.first_name || ""} ${currentVacancyApplication?.candidate?.patronymic_name || ""}`.trim()
                        : "Имя кандидата не указано"}
                    </Text>
                    <Flex gap="16px" alignItems="center">
                      <Text borderRadius="15px" padding="2px 8px" color="#3b515e" bgColor="#f1f5f9" fontSize={16} fontWeight={600}>
                        {currentVacancyApplication?.status?.name || "Статус не указан"}
                      </Text>
                    </Flex>
                  </Flex>
                  <Flex justifyContent="space-between" w="100%">
                    <Flex flexDirection="column" gap="8px">
                      <Text height="max-content" color="#65758b" fontSize={14} fontWeight={500}>
                        {" "}
                        <Icon as={FiClock as any} boxSize={4} /> Дней в статусе: {getDaysDifferent(currentVacancyApplication.status.changed_at)} д
                      </Text>
                      <Text height="max-content" color="#65758b" fontSize={14} fontWeight={500}>
                        {" "}
                        Ответственный рекрутер: {currentVacancyApplication.created_by?.username || "—"}
                      </Text>
                    </Flex>
                    <Button alignSelf="flex-end" variant="outline" onClick={() => onOpen()}>
                      Перейти к следующему этапу
                    </Button>
                  </Flex>
                </Flex>
                <Grid templateColumns="repeat(3, 1fr)" gap="24px" templateRows="88px" marginTop="16px">
                  <GridItem colSpan={1} border="1px solid #e1e7ef" borderRadius="15px" padding="16px" backgroundColor="white">
                    <Flex flexDirection="column" gap="8px">
                      <Text fontSize={14} fontWeight={600} color="#65758b">
                        Внутренняя ставка:
                      </Text>
                      <Text fontSize={18} fontWeight={600} color="#3b515e">
                        {currentVacancyApplication.candidate.internal_rate || "—"}
                      </Text>
                    </Flex>
                  </GridItem>
                  <GridItem colSpan={1} border="1px solid #e1e7ef" borderRadius="15px" padding="16px" backgroundColor="white">
                    <Flex flexDirection="column" gap="8px">
                      <Text fontSize={14} fontWeight={600} color="#65758b">
                        Источник:
                      </Text>
                      <Text fontSize={18} fontWeight={600} color="#3b515e">
                        {currentVacancyApplication.candidate.source.name || "—"}
                      </Text>
                    </Flex>
                  </GridItem>
                  <GridItem colSpan={1} border="1px solid #e1e7ef" borderRadius="15px" padding="16px" backgroundColor="white">
                    <Flex flexDirection="column" gap="8px">
                      <Text fontSize={14} fontWeight={600} color="#65758b">
                        Дата прикрепления:
                      </Text>
                      <Text fontSize={18} fontWeight={600} color="#3b515e">
                        {currentVacancyApplication.created_at ? formatDate(currentVacancyApplication.created_at) : "—"}
                      </Text>
                    </Flex>
                  </GridItem>
                </Grid>
                <Tabs defaultIndex={tabIndex} onChange={setDefaultTabParam} height="100%" marginTop="16px">
                  <ChakraTabs tabs={AnnexTabList} />
                  <Box marginTop="10px" h="1px" w="100%"></Box>
                  <TabPanels height="90%">
                    <TabPanel height="100%" bgColor="white" padding="16px" border="1px solid #e1e7ef" borderRadius="15px">
                      <Flex flexDirection="column" height="100%" justifyContent="space-between">
                        <AnnexEventsBlock events={currentVacancyApplication?.events ?? []} />
                        <Flex width={"100%"} gap="24px">
                          <BaseTextArea
                            containerStyles={{ width: "100%" }}
                            name={"comment"}
                            value={commentText}
                            onChange={(e) => setCommentText(e.target.value)}
                            placeholder="Комментарий к этапу"
                            onBlur={formikComment.handleChange}
                          ></BaseTextArea>
                          <Button
                            height="100%"
                            onClick={() => {
                              formikComment.handleSubmit();
                            }}
                          >
                            Отправить
                          </Button>
                        </Flex>
                      </Flex>
                    </TabPanel>
                    {/* <TabPanel px={0} pb={0}>
                    <Flex maxH="57vh" overflow="auto">
                      <Flex flexDirection="column" gap="16px" w="40%">
                        <TitleWithValue
                          title="Ответственный рекрутер"
                          value={currentVacancyApplication.created_by?.username}
                        />
                        <Text marginTop="16px" fontSize="24px" fontWeight={500}>
                          Информация:
                        </Text>
                        <TitleWithValue title="Зарплата, на руки" value={`${currentVacancyApplication.candidate?.expected_salary?.sum ?? ""}${currentVacancyApplication.candidate?.expected_salary?.currency?.name ? ` (${currentVacancyApplication.candidate.expected_salary.currency.name})` : ''}`} />
                        <TitleWithValue title="Грейд" value={currentVacancyApplication.candidate?.grade?.name ?? ''} />
                        <TitleWithValue
                          title="Страна проживания"
                          value={currentVacancyApplication.candidate?.country?.name}
                        />
                        <TitleWithValue
                          title="Город проживания"
                          value={currentVacancyApplication.candidate?.town}
                        />
                        <Text marginTop="16px" fontSize="24px" fontWeight={500}>
                          Контакты:
                        </Text>
                        <TitleWithValue title="Email" value={currentVacancyApplication.candidate?.contact_email} />
                        <TitleWithValue
                          title="Телефон"
                          value={currentVacancyApplication.candidate?.contact_phone}
                        />
                        <TitleWithValue title="Telegram" value={currentVacancyApplication.candidate?.contact_telegram} />
                        <TitleWithValue title="Доп. контакты" value={currentVacancyApplication.candidate?.contacts} />
                        <TitleWithValue
                          title="Дата рождения"
                          value={currentVacancyApplication.candidate?.birthday}
                        />
                      </Flex>
                    </Flex>
                  </TabPanel> */}
                    <TabPanel px={0} pb={0}>
                      <FileUploader
                        handleSingleFileDelete={handleDelete}
                        onChange={(files) => handleAddFiles(files)}
                        currentFiles={currentFiles ?? []}
                        isAnnexPage
                        singleFile={true}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Flex>
            </Flex>
            <MainModal
              onConfirm={formikStatus.handleSubmit}
              isOpen={isOpen}
              onClose={onClose}
              title={"Изменить этап"}
              isDisabled={!formikStatus.values.status || (withDate && !formikStatus.values.scheduled_at) || (currentReasons && currentReasons.length > 0 && !formikStatus.values.reason_id)}
            >
              <Flex flexDirection="column" gap="16px">
                <Flex flexDirection="column" gap="8px">
                  <VacancyApplicationStatusSelect
                    vacancyId={currentVacancyApplication?.vacancy?.id}
                    selectedValue={formikStatus.values.status}
                    name={"status"}
                    onChange={(el) => {
                      formikStatus.setFieldValue("scheduled_at", "");
                      formikStatus.setFieldValue("status", el?.value);
                      formikStatus.setFieldValue("reason_id", null);
                      setCurrentReasons(el.reasons);
                      setWithDate(el?.is_sheduled);
                      if (el.label.includes("Собеседование")) {
                        setWithTime(true);
                      } else {
                        setWithTime(false);
                      }
                    }}
                  />
                  {(!!currentReasons && currentReasons.length > 0) ? (
                    <BaseSelect
                      fieldTitle="Причина"
                      options={currentReasons.map((reason) => ({
                        value: reason.id,
                        label: reason.name,
                      }))}
                      requiredField={true}
                      placeholder="Выберите юр. лицо"
                      value={formikStatus.values.reason_id}
                      onChange={(el) => {formikStatus.setFieldValue("reason_id", el)}}
                      containerStyles={{ width: "100%", minWidth: "300px" }}
                    />
                  ) : <></>}
                  {withDate && (
                    <Flex flexDirection="column" gap="8px">
                      <Text>Дата</Text>
                      <Flex gap="16px">
                        <Input
                          type="date"
                          name="scheduled_at"
                          onChange={(e) => {
                            const date = new Date(e.target.value);
                            const currentTime = formikStatus.values.scheduled_at
                              ? new Date(Number(formikStatus.values.scheduled_at) * 1000)
                              : new Date();
                            date.setHours(currentTime.getHours());
                            date.setMinutes(currentTime.getMinutes());
                            formikStatus.setFieldValue("scheduled_at", Math.floor(date.getTime() / 1000));
                          }}
                          value={
                            formikStatus.values.scheduled_at
                              ? new Date(Number(formikStatus.values.scheduled_at) * 1000).toISOString().split("T")[0]
                              : ""
                          }
                        />
                        {withTime && (
                          <Input
                            type="time"
                            onChange={(e) => {
                              const time = e.target.value.split(":");
                              const currentDate = formikStatus.values.scheduled_at
                                ? new Date(Number(formikStatus.values.scheduled_at) * 1000)
                                : new Date();
                              currentDate.setHours(Number(time[0]));
                              currentDate.setMinutes(Number(time[1]));
                              formikStatus.setFieldValue("scheduled_at", Math.floor(currentDate.getTime() / 1000));
                            }}
                            value={
                              formikStatus.values.scheduled_at
                                ? new Date(Number(formikStatus.values.scheduled_at) * 1000).toTimeString().slice(0, 5)
                                : ""
                            }
                          />
                        )}
                      </Flex>
                    </Flex>
                  )}
                </Flex>
                <BaseTextArea
                  minH={"300px"}
                  fieldTitle={"Комментарий"}
                  value={formikStatus.values.comment}
                  name={"comment"}
                  onChange={formikStatus.handleChange}
                />
              </Flex>
            </MainModal>
            <Modal isOpen={isDeleteModalOpen} onClose={onDeleteModalClose} isCentered>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Открепление кандидата</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Text>Вы уверены, что хотите открепить кандидата от вакансии?</Text>
                </ModalBody>
                <ModalFooter gap="16px">
                  <Button variant="ghost" onClick={onDeleteModalClose}>
                    Нет
                  </Button>
                  <Button colorScheme="red" onClick={handleDeleteApplication}>
                    Да
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Flex>
        )}
      </PageLoaderWrapper>
    </Layout>
  );
};
